import { Box, IconBox, Row, Text } from "@hightouch/htui";
import { singular } from "pluralize";

import { FilterableOptionsContextValue } from "src/components/explore/filter-popover/filterable-options-hook";
import {
  EventIcon,
  FilterOption,
  RealtimeEventIcon,
  RelationIcon,
} from "src/components/explore/filter-popover/constants";

interface WhereEachTextProps {
  modelName?: string | null;
  filterOptionType?: FilterableOptionsContextValue["parentFilterOptionType"];
  iconOverride?: FilterableOptionsContextValue["parentIconOverride"];
  semanticType?: string | null;
}

const getIcon = (
  filterOptionType?: WhereEachTextProps["filterOptionType"],
  iconOverride?: WhereEachTextProps["iconOverride"],
) => {
  if (iconOverride) {
    return (
      <IconBox
        size="sm"
        icon={iconOverride.icon}
        color={iconOverride.color}
        variant={iconOverride.variant}
      />
    );
  }
  switch (filterOptionType) {
    // TODO(nolan): these shades should also be drawn from the constants file, that file really needs a refactor
    case FilterOption.Event:
      return <EventIcon color="teal" />;
    case FilterOption.RealtimeEvent:
      return <RealtimeEventIcon color="teal" />;
    case FilterOption.MessageEvent:
    case FilterOption.Relation:
    default:
      return <RelationIcon color="green" />;
  }
};

export const WhereEachText = (props: WhereEachTextProps) => {
  const { modelName, filterOptionType, iconOverride, semanticType } = props;
  return (
    <Text as={Row} display="inline-flex" align="center">
      <Text as={Row} alignSelf="center" mr={1}>
        Where each{semanticType ? ` ${singular(semanticType)} in` : ""}
      </Text>
      <Box
        p={2}
        height="24px"
        display="inline-flex"
        borderRadius="12px"
        bg="base.background"
        alignItems="center"
        gap={1}
        maxWidth="200px"
      >
        {getIcon(filterOptionType, iconOverride)}
        <Text isTruncated>{modelName}</Text>
      </Box>
    </Text>
  );
};
